__webpack_require__.p = "/solar/quote/";